import React from 'react';
import { Box, Typography, Chip, Switch, FormControlLabel } from '@mui/material';
import { CheckCircle, Error, CloudUpload } from '@mui/icons-material';

const AutosaveIndicator = ({ lastSaved, saving, enabled, onToggle }) => {
  const formatTime = (date) => {
    if (!date) return 'Never';
    return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2, p: 1, bgcolor: 'background.default', borderRadius: 1 }}>
      {saving ? (
        <Chip
          icon={<CloudUpload />}
          label="Saving..."
          size="small"
          color="primary"
        />
      ) : lastSaved ? (
        <Chip
          icon={<CheckCircle />}
          label={`Saved at ${formatTime(lastSaved)}`}
          size="small"
          color="success"
        />
      ) : (
        <Chip
          icon={<Error />}
          label="Not saved"
          size="small"
          color="default"
        />
      )}

      <FormControlLabel
        control={<Switch checked={enabled} onChange={onToggle} size="small" />}
        label="Auto-save"
      />
    </Box>
  );
};

export default AutosaveIndicator;
